<template>
    <div class="row">
        <help-modal/>
        <div class="col-lg-6">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('show_message') }}</h4>
                    <div class="ibox-tools">
                        <button-open-help-modal :helpName="helpName" :inExtraDiv="false"/>
                    </div>
                </div>
                <div class="ibox-content">
                    <div class="form-group row">
                        <div class="col-md-12 ">
                            <h3>{{ __('subject') }}: {{ thread.subject }}</h3>
                            <p>{{ __('category') }}: <strong>{{ thread.category_name }}</strong> | Status:
                                <span class="status-span label" :class="threadStatusLabel">
                                    {{ __(this.status) }}
                                </span>
                                <br>
                                {{ __('recivers') }}:
                                <span v-if="typeof thread.users === 'string' || thread.users instanceof String">
                                    <strong>{{ thread.users }}</strong>
                                </span>
                                <span v-else v-for="(user, name, index) in thread.users">
                                    <strong>{{ user.name }} {{ user.surname }}</strong>
                                    <span v-if="Object.keys(thread.users).length > index + 1"> | </span>
                                </span>
                            <hr>
                        </div>

                        <div v-for="message in thread.messages" class="col-md-12 m-b-sm">
                            <p>{{ formattedDate(message.date) }} |
                                <strong v-if="message.sender">{{ message.sender }} </strong> do: {{message.recivers}}</p>
                            <span v-html="message.body"> </span>

                            <p v-for="media in message.media"><a  target="_blank" :href="getDownloadRouth(media.id, thread.instance_id)"><i class="fa fa-paperclip"></i>{{media.file_name}}</a><br></p>
                            <hr>
                        </div>

                        <!-- message body -->
                        <div class="col-12">
                            <b-form-group
                                :label="__('reply') + '*'"
                                :invalid-feedback="invalidFeedback('body')"
                                :state="checkState('body')"
                            >
                                <textarea name="value" class="form-control communication-message-summernote" id="body"></textarea>
                            </b-form-group>
                        </div>

                        <div class="col-md-12 "><label><input v-model="requireAnswer" type="checkbox"> {{ __('require_answer') }}</label></div>

                    </div>
                    <div class="form-group row m-b-sm" v-for="(file, index) in files">
                        <div class="col">
                            <input type="text" class="form-control" :value="file.name" disabled>
                        </div>

                        <!-- delete attachment button -->
                        <div class="col-md-auto table-icons doc-service text-right">
                            <a @click="deleteAttachment(index)">
                                <i class="fa fa-trash pt-2"/>
                            </a>
                        </div>
                    </div>
                    <div class="row m-b">
                        <div class="col-md-12">
                            <input type="file" ref="file" style="display: none" @change="handleFileUploads">
                            <a @click="$refs.file.click()" class="btn btn-primary">
                                <i class="fa fa-plus"></i> {{ __('add_attachment') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ibox">
                <div class="ibox-content">
                    <div class="row">
                        <div class="col-sm-4">
                            <a :href="cancelUrl()" class="btn btn-white btn-sm">{{ __('cancel') }}</a>
                            <a @click="store()" class="btn btn-primary btn-sm">{{ __('send') }} </a>
                        </div>
                        <div class="col-sm-8 text-right">
                            <a v-if="this.status != 'closed'" :href="closeThreadUrl()" class="btn btn-primary btn-sm hide-info">{{ __('close_thread') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelpModal from "../../../../components/help/HelpModal";
import ButtonOpenHelpModal from "../../../../components/help/ButtonOpenHelpModal";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/pl';

import $ from 'jquery';

export default {
    name: "Show",
    data() {
        return {
            helpName: "PMC-001",
            body: null,
            requireAnswer: false,
            files: [],

            editor: DecoupledEditor,
            editorConfig: {
                language: 'pl',
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        'underline',
                        'removeFontStyle',
                        'fontSize',
                        'fontColor'
                    ]
                }
            }
        }
    },
    components: {
        HelpModal,
        ButtonOpenHelpModal
    },
    props: {
        thread: {
            required: true,
            type: Object
        },
        sa : {
            required: true
        },
        prefix : false,
        status : false,
        placeOfShipment : false

    },
    mounted() {
        toggleLoader(false)
    },
    computed: {
        threadStatusLabel() {
            switch (this.status) {
                case'open':
                    return 'label-primary';
                case 'closed':
                    return 'label-default';
                case 'waiting_for_reply':
                    return 'label-warning';
                case 'needs_reply':
                    return 'label-danger';
            }
        }
    },
    methods: {
        cancelUrl() {
            let space = this.placeOfShipment == 'mail' ? 'index' : 'listCoummunication';
            let urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('unread_message')) {
               return '/communication/message/'+this.prefix+'/0/'+space+'?unread_message%5B%5D=1&filter=filtered';
            };
            return '/communication/message/'+this.prefix+'/0/'+space+'?filters_reset=true';
        },
        getDownloadRouth(media, instance) {
           var fullUrl = this.sa ? window.location.origin + "/communication/message/super_admin_communication/0/" + media + "/" + instance +"/download" : window.location.origin + "/communication/message/client_communication/0/" + media + "/" + instance +"/download";
           return fullUrl;
        },
        onReady(editor) {
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        store() {
           self = this;
            this.axios.post('/communication/message/'+ this.prefix +'/reply', this.prepareDataForStore())
                .then(response => {
                    toastr['success'](this.__(response.data.notification.message)).css('border', '0px');
                    if(self.placeOfShipment == 'list') {
                        window.location.href = '/communication/message/' + this.prefix + '/0/listCoummunication';
                        return;
                    }
                    window.location.href = '/communication/message/' + this.prefix + '/0/index';
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
        },
        handleFileUploads(event) {
            this.files.push(...event.target.files);
            this.$refs.file.value = null;
        },
        prepareDataForStore() {
            let formData = new FormData();

            formData.set('thread_id', this.thread.id);
            formData.set('is_from_sa', this.thread.is_from_sa ? '1' : '');
            formData.set('body', $('#body').val() ?? '');
            formData.set('require_answer', this.requireAnswer ? this.requireAnswer : '');
            formData.set('place_of_shipment', this.placeOfShipment);

            if (this.files.length) {
                this.files.forEach(file => {
                    formData.append('files[]', file);
                });
            }

            return formData;
        },
        formattedDate(date) {
            return date;
        },
        invalidFeedback(type) {
            if (this.errors && this.errors[type]) {
                return this.errors[type][0];
            }
        },
        checkState(type) {
            return !(this.errors && this.errors[type]);
        },
        closeThreadUrl() {
           if(this.placeOfShipment == 'mail') {
              return  '/communication/message/' + this.prefix +'/'+this.thread.is_from_sa+'/'+this.thread.id+ '/closeThread?url='+document.referrer;
           }
           return  '/communication/message/' + this.prefix +'/'+this.thread.is_from_sa+'/'+this.thread.id+ '/listCloseThread?url='+document.referrer;
        }
    }
}
</script>

<style lang="scss">
.ck-editor__editable_inline {
    height: 150px !important;
    border: 1px #EBEBE4 solid !important;
}
</style>
